import React, { useEffect, useState } from 'react';

import { useMyOrders } from '../../state/swapV3';
import { refSwapV3OldVersionViewFunction } from '../../services/near';
import { UserOrderInfo } from '../../services/swapV3';
import { useTokens, useTokenPriceList } from '../../state/token';
import { Loading } from '../icon/Loading';
import { useWalletSelector } from '../../context/WalletSelectorContext';
import { useHistoryOrderSwapInfo } from '../../state/myOrder';
import _ from 'lodash';
import { PriceContext } from './myOrder/myOrderShared';
import { OrderCard } from './myOrder/OrderCard';

function MyOrderComponent() {
  const { activeOrder, historyOrder } = useMyOrders();

  const [oldOrders, setOldOrders] = useState<UserOrderInfo[]>();

  const { accountId } = useWalletSelector();

  useEffect(() => {
    refSwapV3OldVersionViewFunction({
      methodName: 'list_active_orders',
      args: {
        account_id: accountId,
      },
    }).then((fetchedOldOrders) => {
      setOldOrders(fetchedOldOrders);
    });
  }, [accountId]);

  const minOrderTime =
    _.minBy(historyOrder, (order) => order.created_at)?.created_at || 0;

  const historySwapInfo = useHistoryOrderSwapInfo({
    start_at: Number(minOrderTime),
    end_at: Date.now() * 1000000,
  });

  const tokenPriceList = useTokenPriceList();

  const ActiveTokenIds = activeOrder
    ?.map((order) => [order.sell_token, order.buy_token])
    .flat();

  const HistoryTokenIds = historyOrder
    ?.map((order) => [order.sell_token, order.buy_token])
    .flat();

  const OldActiveTokenIds =
    oldOrders?.map((order) => [order.sell_token, order.buy_token]).flat() || [];

  const HistorySwapInfoTokenIds =
    historySwapInfo
      ?.map((historySwap) => [historySwap.token_in, historySwap.token_out])
      .flat() || [];

  const tokenIds =
    !activeOrder || !historyOrder
      ? null
      : [
          ...new Set([
            ...ActiveTokenIds,
            ...HistoryTokenIds,
            ...OldActiveTokenIds,
            ...HistorySwapInfoTokenIds,
          ]),
        ];

  const tokens = useTokens(tokenIds || []);

  if (!accountId) return null;

  if (
    !tokenIds ||
    !activeOrder ||
    !historyOrder ||
    (tokenIds?.length > 0 && tokens?.length === 0)
  ) {
    return <Loading />;
  }

  const tokensMap = tokens.reduce((tokensById, token, index) => {
    return {
      ...tokensById,
      [token.id]: token,
    };
  }, {});

  return (
    <div className="max-w-7xl mx-auto flex flex-col xs:w-full md:5/6 lg:w-full">
      <PriceContext.Provider value={tokenPriceList}>
        <OrderCard
          tokensMap={tokensMap}
          activeOrder={activeOrder}
          historyOrder={historyOrder}
          historySwapInfo={historySwapInfo}
        />
      </PriceContext.Provider>
    </div>
  );
}

export default MyOrderComponent;
